import { render, staticRenderFns } from "./changePassWord.vue?vue&type=template&id=44187b94"
import script from "./changePassWord.vue?vue&type=script&lang=js"
export * from "./changePassWord.vue?vue&type=script&lang=js"
import style0 from "./changePassWord.vue?vue&type=style&index=0&id=44187b94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports